import dayjs from "dayjs";
import { Typography } from "components/atoms";
import { RadioInput } from "components/molecules/OnboardingFormAnswer/RadioInput";
import { OnboardingFormQuestion } from "components/molecules/OnboardingFormQuestion";
import { DatePickerInput } from "components/molecules/OnboardingFormAnswer/DatePickerInput";
import { UploadInput } from "components/molecules/OnboardingFormAnswer/UploadInput";
import { AcknowledgeInput } from "components/molecules/OnboardingFormAnswer/AcknowledgeInput";
import { QuestionType } from "utils/types/OnboardingForms";
import { TableInput } from "components/molecules/OnboardingFormAnswer/TableInput";
import { ValidateErrorIcon } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  questions: QuestionType[] | undefined;
  errorResponse: any;
  // answer: any;
  allAnswers: any;
  testDate?: string;
  onAnswerChange: (id: string, value: any, type?: string) => void;
}

export const RendererScoreInfo = ({
  questions,
  errorResponse,
  // answer,
  allAnswers,
  testDate,
  onAnswerChange,
}: IProps) => {
  return questions ? (
    <>
      <div className="question-and-answers-wrapper">
        <OnboardingFormQuestion question={`1. ${questions[0].Label}`} />
        <div className="onb-form-answer-wrapper">
          <RadioInput
            options={questions[0].Choices}
            // value={typeof answer === "string" ? answer : answer?.answer}
            value={allAnswers[questions[0].FieldName]}
            name={questions[0].FieldName}
            onChange={(value: any) =>
              onAnswerChange(questions[0].FieldName, value)
            }
          />
        </div>
      </div>
      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`2. ${questions[0].SubQuestions[0].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[0].SubQuestions[0].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[0].SubQuestions[0].FieldName]}
              name={questions[0].SubQuestions[0].FieldName}
              onChange={(value: any) =>
                questions[0].SubQuestions &&
                onAnswerChange(questions[0].SubQuestions[0].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {/* Begin Question 1 - Yes, QUestion 2 - Yes path */}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`2a. ${questions[0].SubQuestions[0].SubQuestions[0].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <DatePickerInput
              placeholder="DD/MM/YY"
              isDisableFutureDates={true}
              question={{}}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[0].FieldName
                ]
              }
              onChange={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[0].FieldName,
                  value
                )
              }
            />
          </div>
          {errorResponse?.data?.Errors?.hasOwnProperty(
            questions[0].SubQuestions[0].SubQuestions[0].FieldName
          ) ? (
            <div className="form-input-errors-wrapper">
              <div className="icon-with-error-wrapper">
                <ValidateErrorIcon />
                <Typography
                  label={
                    errorResponse?.data?.Errors[
                      questions[0].SubQuestions[0].SubQuestions[0].FieldName
                    ]
                  }
                  variant="h6Book"
                  styles="error-msg-custom-style"
                />
              </div>
            </div>
          ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`2b. ${questions[0].SubQuestions[0].SubQuestions[1].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <TableInput
              format={"multiple"}
              scoreViewModel={questions[0].SubQuestions[0].SubQuestions[1]}
              goalViewModel={questions[0].SubQuestions[0].SubQuestions[2]}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[1].FieldName
                ]
              }
              onChangeTestScore={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[1].FieldName,
                  value
                )
              }
              onChangeGoalScore={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[2].FieldName,
                  value
                )
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <>
          <div className="question-and-answers-wrapper">
            <OnboardingFormQuestion
              question={`2c. ${questions[0].SubQuestions[0].SubQuestions[3].Label}`}
            />
            <div className="onb-form-answer-wrapper">
              <UploadInput
                value={
                  allAnswers[
                    questions[0].SubQuestions[0].SubQuestions[3].FieldName
                  ]
                }
                onChange={(value: any) =>
                  questions[0].SubQuestions &&
                  questions[0].SubQuestions[0].SubQuestions &&
                  onAnswerChange(
                    questions[0].SubQuestions[0].SubQuestions[3].FieldName,
                    value
                  )
                }
              />
            </div>
            {errorResponse?.data?.Errors?.hasOwnProperty(
              questions[0].SubQuestions[0].SubQuestions[3].FieldName
            ) ? (
              <div className="form-input-errors-wrapper">
                <div className="icon-with-error-wrapper">
                  <ValidateErrorIcon />
                  <Typography
                    label={
                      errorResponse?.data?.Errors[
                        questions[0].SubQuestions[0].SubQuestions[3].FieldName
                      ]
                    }
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              </div>
            ) : null}
          </div>
        </>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[1] ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion question={`3. ${questions[1].Label}`} />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[1].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[1].FieldName]}
              name={questions[1].FieldName}
              onChange={(value: any) =>
                onAnswerChange(questions[1].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions ? (
        <>
          <div className="question-and-answers-wrapper-with-date">
            <div className="question-and-answers-wrapper">
              <OnboardingFormQuestion
                question={`3a. ${questions[1].SubQuestions[0].Label}`}
              />
              <div className="onb-form-answer-wrapper">
                <DatePickerInput
                  placeholder="DD/MM/YY"
                  question={{
                    guaranteeGuidelineTitle:
                      "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                    guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                    PSOTagetTestDate: testDate,
                  }}
                  value={allAnswers[questions[1].SubQuestions[0].FieldName]}
                  onChange={(value: any) =>
                    questions[1].SubQuestions &&
                    onAnswerChange(
                      questions[1].SubQuestions[0].FieldName,
                      value
                    )
                  }
                />
              </div>
              {errorResponse?.data?.Errors?.hasOwnProperty(
                questions[1].SubQuestions[0].FieldName
              ) ? (
                <div className="form-input-errors-wrapper">
                  <div className="icon-with-error-wrapper">
                    <ValidateErrorIcon />
                    <Typography
                      label={
                        errorResponse?.data?.Errors[
                          questions[1].SubQuestions[0].FieldName
                        ]
                      }
                      variant="h6Book"
                      styles="error-msg-custom-style"
                    />
                  </div>
                </div>
              ) : null}
            </div>
            {dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
              dayjs(testDate)
            ) ? (
              <div className="past-date-error-wrapper">
                <Typography
                  label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                  variant="h6Medium"
                  styles="past-date-custom-error-style"
                />
              </div>
            ) : null}
          </div>
        </>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions ? (
        <>
          <div className="question-and-answers-wrapper-with-date">
            <div className="question-and-answers-wrapper">
              <OnboardingFormQuestion
                question={`4. ${questions[1].SubQuestions[1].Label}`}
              />
              <div className="onb-form-answer-wrapper">
                <DatePickerInput
                  placeholder="DD/MM/YY"
                  question={{
                    guaranteeGuidelineTitle:
                      "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                    guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                    PSOTagetTestDate: testDate,
                  }}
                  value={allAnswers[questions[1].SubQuestions[1].FieldName]}
                  onChange={(value: any) =>
                    questions[1].SubQuestions &&
                    questions[1].SubQuestions[1] &&
                    onAnswerChange(
                      questions[1].SubQuestions[1].FieldName,
                      value
                    )
                  }
                />
              </div>
              {errorResponse?.data?.Errors?.hasOwnProperty(
                questions[1].SubQuestions[1].FieldName
              ) ? (
                <div className="form-input-errors-wrapper">
                  <div className="icon-with-error-wrapper">
                    <ValidateErrorIcon />
                    <Typography
                      label={
                        errorResponse?.data?.Errors[
                          questions[1].SubQuestions[1].FieldName
                        ]
                      }
                      variant="h6Book"
                      styles="error-msg-custom-style"
                    />
                  </div>
                </div>
              ) : null}
            </div>
            {dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
              dayjs(testDate)
            ) ? (
              <div className="past-date-error-wrapper">
                <Typography
                  label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                  variant="h6Medium"
                  styles="past-date-custom-error-style"
                />
              </div>
            ) : null}
          </div>
        </>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === true &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {/* End Question 1 - Yes, QUestion 2 - Yes path */}

      {/* Begin Question 1 - Yes, QUestion 2 - No path */}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`2a. ${questions[0].SubQuestions[0].SubQuestions[2].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <TableInput
              format={"single"}
              goalViewModel={questions[0].SubQuestions[0].SubQuestions[2]}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[2].FieldName
                ]
              }
              onChangeGoalScore={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[2].FieldName,
                  value
                )
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      questions[1] ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion question={`3. ${questions[1].Label}`} />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[1].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[1].FieldName]}
              name={questions[1].FieldName}
              onChange={(value: any) =>
                onAnswerChange(questions[1].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`4. ${questions[1].SubQuestions[1].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <DatePickerInput
              placeholder="DD/MM/YY"
              question={{
                guaranteeGuidelineTitle:
                  "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                PSOTagetTestDate: testDate,
              }}
              value={allAnswers[questions[1].SubQuestions[1].FieldName]}
              onChange={(value: any) =>
                questions[1].SubQuestions &&
                questions[1].SubQuestions[1] &&
                onAnswerChange(questions[1].SubQuestions[1].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`3a. ${questions[1].SubQuestions[0].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <DatePickerInput
              placeholder="DD/MM/YY"
              question={{
                guaranteeGuidelineTitle:
                  "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                PSOTagetTestDate: testDate,
              }}
              value={allAnswers[questions[1].SubQuestions[0].FieldName]}
              onChange={(value: any) =>
                questions[1].SubQuestions &&
                questions[1].SubQuestions[0] &&
                onAnswerChange(questions[1].SubQuestions[0].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === true &&
      questions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].FieldName] === false &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {/* End Question 1 - Yes, QUestion 2 - No path */}

      {/* Begin Question 1 - No path */}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`2. ${questions[0].SubQuestions[0].SubQuestions[2].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <TableInput
              format={"single"}
              goalViewModel={questions[0].SubQuestions[0].SubQuestions[2]}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[2].FieldName
                ]
              }
              onChangeGoalScore={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[2].FieldName,
                  value
                )
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`3. ${questions[0].SubQuestions[0].SubQuestions[4].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[0].SubQuestions[0].SubQuestions[4].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[4].FieldName
                ]
              }
              name={questions[0].SubQuestions[0].SubQuestions[4].FieldName}
              onChange={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[4].FieldName,
                  value
                )
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        false &&
      questions[1] ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion question={`4. ${questions[1].Label}`} />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[1].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[1].FieldName]}
              name={questions[1].FieldName}
              onChange={(value: any) =>
                onAnswerChange(questions[1].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        false &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper-with-date">
          <div className="question-and-answers-wrapper">
            <OnboardingFormQuestion
              question={`5. ${questions[1].SubQuestions[1].Label}`}
            />
            <div className="onb-form-answer-wrapper">
              <DatePickerInput
                placeholder="DD/MM/YY"
                question={{
                  guaranteeGuidelineTitle:
                    "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                  guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                  PSOTagetTestDate: testDate,
                }}
                value={allAnswers[questions[1].SubQuestions[1].FieldName]}
                onChange={(value: any) =>
                  questions[1].SubQuestions &&
                  onAnswerChange(questions[1].SubQuestions[1].FieldName, value)
                }
              />
            </div>
          </div>
          {dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
            dayjs(testDate)
          ) ? (
            <div className="past-date-error-wrapper">
              <Typography
                label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                variant="h6Medium"
                styles="past-date-custom-error-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        false &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        false &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper-with-date">
          <div className="question-and-answers-wrapper">
            <OnboardingFormQuestion
              question={`4a. ${questions[1].SubQuestions[0].Label}`}
            />
            <div className="onb-form-answer-wrapper">
              <DatePickerInput
                placeholder="DD/MM/YY"
                question={{
                  guaranteeGuidelineTitle:
                    "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                  guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                  PSOTagetTestDate: testDate,
                }}
                value={allAnswers[questions[1].SubQuestions[0].FieldName]}
                onChange={(value: any) =>
                  questions[1].SubQuestions &&
                  onAnswerChange(questions[1].SubQuestions[0].FieldName, value)
                }
              />
            </div>
          </div>
          {dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
            dayjs(testDate)
          ) ? (
            <div className="past-date-error-wrapper">
              <Typography
                label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                variant="h6Medium"
                styles="past-date-custom-error-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        false &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {/* Begin 3 yes path */}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      questions[0].SubQuestions[0].SubQuestions[4].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion
            question={`3a. ${questions[0].SubQuestions[0].SubQuestions[4].SubQuestions[0].Label}`}
          />
          <div className="onb-form-answer-wrapper">
            <DatePickerInput
              placeholder="DD/MM/YY"
              question={{
                guaranteeGuidelineTitle: `To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.`,
                guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                PSOTagetTestDate: testDate,
              }}
              value={
                allAnswers[
                  questions[0].SubQuestions[0].SubQuestions[4].SubQuestions[0]
                    .FieldName
                ]
              }
              onChange={(value: any) =>
                questions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions &&
                questions[0].SubQuestions[0].SubQuestions[4].SubQuestions &&
                onAnswerChange(
                  questions[0].SubQuestions[0].SubQuestions[4].SubQuestions[0]
                    .FieldName,
                  value
                )
              }
            />
          </div>
          {errorResponse?.data?.Errors?.hasOwnProperty(
              questions[0].SubQuestions[0].SubQuestions[4].SubQuestions[0].FieldName
            ) ? (
              <div className="form-input-errors-wrapper">
                <div className="icon-with-error-wrapper">
                  <ValidateErrorIcon />
                  <Typography
                    label={
                      errorResponse?.data?.Errors[
                        questions[0].SubQuestions[0].SubQuestions[4].SubQuestions[0].FieldName
                      ]
                    }
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              </div>
            ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      questions[1] ? (
        <div className="question-and-answers-wrapper">
          <OnboardingFormQuestion question={`4. ${questions[1].Label}`} />
          <div className="onb-form-answer-wrapper">
            <RadioInput
              options={questions[1].Choices}
              // value={typeof answer === "string" ? answer : answer?.answer}
              value={allAnswers[questions[1].FieldName]}
              name={questions[1].FieldName}
              onChange={(value: any) =>
                onAnswerChange(questions[1].FieldName, value)
              }
            />
          </div>
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper-with-date">
          <div className="question-and-answers-wrapper">
            <OnboardingFormQuestion
              question={`4a. ${questions[1].SubQuestions[0].Label}`}
            />
            <div className="onb-form-answer-wrapper">
              <DatePickerInput
                placeholder="DD/MM/YY"
                question={{
                  guaranteeGuidelineTitle:
                    "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                  guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                  PSOTagetTestDate: testDate,
                }}
                value={allAnswers[questions[1].SubQuestions[0].FieldName]}
                onChange={(value: any) =>
                  questions[1].SubQuestions &&
                  onAnswerChange(questions[1].SubQuestions[0].FieldName, value)
                }
              />
            </div>
            {errorResponse?.data?.Errors?.hasOwnProperty(
              questions[1].SubQuestions[0].FieldName
            ) ? (
              <div className="form-input-errors-wrapper">
                <div className="icon-with-error-wrapper">
                  <ValidateErrorIcon />
                  <Typography
                    label={
                      errorResponse?.data?.Errors[
                        questions[1].SubQuestions[0].FieldName
                      ]
                    }
                    variant="h6Book"
                    styles="error-msg-custom-style"
                  />
                </div>
              </div>
            ) : null}
          </div>
          {dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
            dayjs(testDate)
          ) ? (
            <div className="past-date-error-wrapper">
              <Typography
                label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                variant="h6Medium"
                styles="past-date-custom-error-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      allAnswers[questions[1].FieldName] === true &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[0].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper-with-date">
          <div className="question-and-answers-wrapper">
            <OnboardingFormQuestion
              question={`5. ${questions[1].SubQuestions[1].Label}`}
            />
            <div className="onb-form-answer-wrapper">
              <DatePickerInput
                placeholder="DD/MM/YY"
                question={{
                  guaranteeGuidelineTitle:
                    "To adhere to the Money Back Guarantee Guidelines, please select a test date within the PSO Target Test Date range.",
                  guaranteeGuidelineCondition: `You’ve selected a test date that’s outside of your guarantee guidelines. Would you like to change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")}?`,
                  PSOTagetTestDate: testDate,
                }}
                value={allAnswers[questions[1].SubQuestions[1].FieldName]}
                onChange={(value: any) =>
                  questions[1].SubQuestions &&
                  onAnswerChange(questions[1].SubQuestions[1].FieldName, value)
                }
              />
            </div>
          </div>
          {dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
            dayjs(testDate)
          ) ? (
            <div className="past-date-error-wrapper">
              <Typography
                label={`You’ve selected a test date that’s outside of your guarantee guidelines. Change your target Test Date to ${dayjs(testDate).format("MMM DD, YYYY")} or before`}
                variant="h6Medium"
                styles="past-date-custom-error-style"
              />
            </div>
          ) : null}
        </div>
      ) : null}

      {allAnswers[questions[0].FieldName] === false &&
      questions[0].SubQuestions &&
      questions[0].SubQuestions[0].SubQuestions &&
      allAnswers[questions[0].SubQuestions[0].SubQuestions[4].FieldName] ===
        true &&
      allAnswers[questions[1].FieldName] === false &&
      questions[1].SubQuestions &&
      dayjs(allAnswers[questions[1].SubQuestions[1].FieldName]).isAfter(
        dayjs(testDate)
      ) &&
      questions[1].SubQuestions &&
      questions[1].SubQuestions[1].SubQuestions ? (
        <div className="question-and-answers-wrapper">
          <AcknowledgeInput
            question={questions[1].SubQuestions[1].SubQuestions[0].Label}
            value={
              allAnswers[questions[1].SubQuestions[1].SubQuestions[0].FieldName]
            }
            onChange={(value: any) =>
              questions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions &&
              questions[1].SubQuestions[1].SubQuestions[0] &&
              onAnswerChange(
                questions[1].SubQuestions[1].SubQuestions[0].FieldName,
                value
              )
            }
          />
        </div>
      ) : null}

      {/* End 3 yes path */}

      {/* End Question 1 - No path */}
    </>
  ) : null;
};
